import Grid from '@mui/material/Grid'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { FormDatePickerPeriod } from 'ui/molecules/pickers/DatePicker/FormDatePickerPeriod'

type PeriodPickerProps = {
  setPeriod: (arg0: Period) => void
}

function PeriodPicker({ setPeriod: submitPeriod }: PeriodPickerProps): ReactElement {
  return (
    <Grid style={{ marginTop: 10 }}>
      <FormDatePickerPeriod
        granularity="day"
        defaultPeriod={{
          startTime: moment().startOf('month'),
          endTime: moment().endOf('month'),
        }}
        onSubmit={submitPeriod}
      />
    </Grid>
  )
}

export default PeriodPicker
